import React from 'react'
import Button from '../atoms/Button'
import Text from '../atoms/TextNew'
import View from '../atoms/View'
import CloseXSvg from '../other/svg/CloseXSvg'

interface Customer {
  id: string
  name: string
  email: string
}

interface DeleteCustomerModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  customer: Customer | null
}

const DeleteCustomerModal = ({ isOpen, onClose, onConfirm, customer }: DeleteCustomerModalProps): JSX.Element => {
  if (!isOpen || customer === null) return <></>

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-4 p-8 max-w-md w-full mx-4 bg-white shadow-bothMedium">
        <View className="flex justify-between items-center mb-6">
          <Text className="text-xl font-Bold text-darkGrey">Delete Customer</Text>
          <Button onClick={onClose} customStyles="text-grey hover:text-darkGrey !bg-white">
            <CloseXSvg className="w-6 h-6 text-darkGrey" />
          </Button>
        </View>

        <div className="mb-6">
          <Text className="text-l text-darkGrey mb-4">Are you sure you want to delete this customer?</Text>
          <div className="bg-lightGrey rounded-2 p-4">
            <Text className="font-SemiBold text-darkGrey">{customer.name}</Text>
            <Text className="text-grey">{customer.email}</Text>
          </div>
          <Text className="text-m text-grey mt-4">This action cannot be undone.</Text>
        </div>

        <View className="flex justify-end gap-4">
          <Button
            onClick={onClose}
            customStyles="px-6 py-3 border border-grey text-darkGrey hover:bg-lightGrey transition-colors rounded-2">
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            color="errorRed"
            customStyles="px-6 py-3 bg-errorRed text-white hover:bg-red-700 transition-colors rounded-2">
            Delete Customer
          </Button>
        </View>
      </div>
    </div>
  )
}

export default DeleteCustomerModal
